import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Paper } from '@mui/material';
import Titlebar from '../TitleBar';
import { TableBody2 } from '.';
import { Pagination, SearchTable, TableHeader } from '../TableTemplate/index';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import { applyFilter, emptyRows, getComparator, extractDate } from '../../Utils/table';
import { selectPressRegPro } from '../Selectors/StitchSelector/StitchingSelectors';
import { PackMenu, PressMenu, TrimmingMenu } from '../TitleList';
import { fetchPressRegProduction } from '../../Store/PHPSlice/Press/PressingApi';
import axios from 'axios';


const PackFlowInwReg = () => {
    const dispatch = useDispatch();
    const baseUrl = process.env.REACT_APP_BASE_URL;
    // const presslist = useSelector(selectPressRegPro);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('empId');
    const [selected, setSelected] = useState([]);
    const [filterName, setFilterName] = useState('null');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState("");
    const [firstIndex, setFirstIndex] = useState(0);
    const [lastIndex, setLastIndex] = useState(0);


    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [pageRange, setPageRange] = useState([0, 10]); // Initial range [0, 10]
    const [searchTerm, setSearchTerm] = useState('');

    const [flowPack, setFlowPack] = useState([]);


    useEffect(() => {
        // dispatch(fetchPressRegProduction());
        fetchPackFlowWise();
    }, [dispatch]);

    const fetchPackFlowWise = async () => {
        try {
            const res = await axios.get(`${baseUrl}?apicall=getFlowWisePackingInwardReg`);
            setFlowPack(res.data?.data);
        } catch (error) {
            console.error('error', error);
        }
    };


    const compData = Array.isArray(flowPack) ? flowPack?.map((item, index) => (
        {
            serialNumber: index + 1,
            srno: item.ID,
            dt: item.date,
            fpkmemo: item.fpkmemo,
            itemId: item.itemId,
            itemNm: item.itemNm,
            firmId: item.firmId,
            firmNm: item.firmNm,
            empNm: item.empNm,
            sono: item.sono,
            orderno: item.orderno,
            soId: item.soId,
            ordtype: item.ordtype,
            prnId: item.prnId,
            prnMemo: item.prnMemo,
            stinwId: item.stinwId,
            streMemo: item.reMemo,
            mclothNm: item.mclothNm,
            m1clothNm: item.m1clothNm,
            m2clothNm: item.m2clothNm,
            m3clothNm: item.m3clothNm,
            totqty: item.totqty,
            inwqty: item.inwqty,
            pkid: item.pkid
        }
    )) : [];



    const handleSort = (event, id) => {
        const isAsc = orderBy === id && order === 'asc';
        if (id !== '') {
            setOrder(isAsc ? 'desc' : 'asc');
            setOrderBy(id);
        }
    };
    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = compData.map((n) => n.name);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }
        setSelected(newSelected);
    };
    const handleChangeCPage = (n) => {
        setCurrentPage(n);
    };
    const handlePrevPage = () => {
        if (currentPage !== firstIndex) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextpage = () => {
        if (currentPage !== lastIndex) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handleRecordsPerPageChange = (event) => {

        setRecordsPerPage(parseInt(event.target.value, 10)); // Parse selected value to integer
        setCurrentPage(0); // Reset current page when records per page changes
    };

    const totalCount = compData ? compData.length : 0;
    const npages = Math.ceil(totalCount / recordsPerPage);
    const numbers = Array.from({ length: npages }, (_, i) => i + 1);


    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1); // Reset to first page on search
    };

    const filteredData = (Array.isArray(compData) ? compData : []).filter(item =>
        item?.date?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.fpkmemo?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.ordtype?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.firmNm?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.sono?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.orderno?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.prnMemo?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.streMemo?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.empNm?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.itemNm?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.mclothNm?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.m1clothNm?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.m2clothNm?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.m3clothNm?.toLowerCase().includes(searchTerm.toLowerCase())
    );


    const renderPaginationButtons = () => {
        let start = Math.max(0, currentPage - 10);
        let end = Math.min(npages, start + 9);

        if (end - start < 9) {
            start = Math.max(1, end - 9);
        }

        return numbers.slice(start - 1, end).map((n) => (

            <button key={n} className={`page-link ${currentPage === n ? 'active' : ''}`} onClick={() => handleChangeCPage(n)}>{n}</button>
        ));
    };

    const handleFilterByName = (event) => {
        setPage(0);
        let value = event.target.value.trim();
        setFilterName(event.target.value);

    };
    const dataFiltered = applyFilter({
        inputData: filteredData,
        comparator: getComparator(order, orderBy),
    });

    // const notFound = !dataFiltered.length;
    const totalPages = Math.ceil(dataFiltered.length / itemsPerPage);
    const displayedData = dataFiltered.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);


    const pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1);
    const visiblePageNumbers = pageNumbers.slice(pageRange[0], pageRange[1]);

    const handleNextPageRange = () => {
        setPageRange([pageRange[0] + 5, pageRange[1] + 5]);
    };

    const handlePreviousPageRange = () => {
        setPageRange([pageRange[0] - 5, pageRange[1] - 5]);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(Number(event.target.value));
        setCurrentPage(1); // Reset to first page on change
    };


    return (
        <>
            <Titlebar data={PackMenu} />

            <div style={{ margin: '1% 0.5%' }}>
                <h2>Packing Inward Register</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>

                            <SearchTable
                                handleItemsPerPageChange={handleItemsPerPageChange}
                                searchTerm={searchTerm}
                                handleSearchChange={handleSearchChange}
                                totalItems={filteredData?.length}
                            />


                            <TableContainer style={{ marginTop: '2%' }}>
                                <Table>
                                    <TableHeader
                                        headCells={
                                            [
                                                { id: 'srno', label: 'SrNo' },
                                                { id: 'date', label: 'Date' },
                                                { id: 'fpkmemo', label: 'Pack Memo' },
                                                { id: 'ordtype', label: 'Order Type' },
                                                { id: 'sono', label: 'SO No.' },
                                                { id: 'orderno', label: 'Order No.' },
                                                { id: 'empNm', label: 'Employee' },
                                                { id: 'itemNm', label: 'Item' },
                                                { id: 'totqty', label: 'Total Issue Qty.' },
                                                { id: 'inwqty', label: 'Total Inward Qty.' },
                                                { id: '', label: 'View' },
                                                // { id: '', label: 'Edit' },
                                                // { id: '', label: 'Delete' }

                                            ]
                                        }
                                        order={order}
                                        orderBy={orderBy}
                                        onRequestSort={handleSort}
                                        numSelected={selected.length}
                                        rowCount={compData.length}
                                        onSelectAllClick={handleSelectAllClick}
                                    />
                                    <tbody>
                                        {displayedData?.map((row) => (
                                            <TableBody2
                                                key={row.srno}
                                                id={row.srno}
                                                serialNumber={row.serialNumber}
                                                srno={row.srno}
                                                dt={row.dt}
                                                fpkmemo={row.fpkmemo}
                                                itemId={row.itemId}
                                                itemNm={row.itemNm}
                                                firmId={row.firmId}
                                                firmNm={row.firmNm}
                                                empNm={row.empNm}
                                                sono={row.sono}
                                                soId={row.soId}
                                                ordtype={row.ordtype}
                                                sts={row.sts}
                                                prnId={row.prnId}
                                                prnMemo={row.prnMemo}
                                                stinwId={row.stinwId}
                                                streMemo={row.streMemo}
                                                mclothNm={row.mclothNm}
                                                m1clothNm={row.m1clothNm}
                                                m2clothNm={row.m2clothNm}
                                                m3clothNm={row.m3clothNm}
                                                totqty={row.totqty}
                                                inwqty={row.inwqty}
                                                orderno={row.orderno}
                                                pkid={row.pkid}
                                                selected={selected.indexOf(row.name) !== -1}
                                                handleClick={(event) => handleClick(event, row.name)}
                                            />
                                        ))}
                                    </tbody>
                                </Table>
                            </TableContainer>


                            <Pagination
                                currentPage={currentPage}
                                handlePageChange={handlePageChange}
                                handlePreviousPageRange={handlePreviousPageRange}
                                visiblePageNumbers={visiblePageNumbers}
                                pageNumber={pageNumbers}
                                pageRange={pageRange}
                                totalPages={totalPages}
                                handleNextPageRange={handleNextPageRange}
                            />
                        </Paper>
                    </Grid>
                </Grid>
            </div>

        </>
    );
}

export default PackFlowInwReg;
